import { Box, Button, Grid, TextField, Tooltip, Select, MenuItem, Divider, CircularProgress, } from "@mui/material";
import React, { useState, useEffect } from "react";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeleteIcon from '@mui/icons-material/Delete';
import axios from '../../../utils/fvAxios';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import fileDownload from "js-file-download";
import Backdrop from "@mui/material/Backdrop";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F2F4F7",
    color: "#101828",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export default function AddEmployee() {
  const INFO = [
    {
      key: "1",
      text: "DL"
    },
    {
      key: "2",
      text: "GC"
    },
    {
      key: "3",
      text: "SSN"
    },
    {
      key: "4",
      text: "PN"
    }
  ]
  const toastNotify = (message, isSuccess = true) => {
    if (isSuccess) {
      toast.success(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };
  const navigate = useNavigate();
  const [getCourse, setCourses] = React.useState('');
  const [VCode, setVCode] = React.useState('');
  const [EmployeeData, setEmployeeData] = useState([]);
  const [fname, setFName] = useState("");
  const [title, setTitle] = useState("");
  const [email, setEmail] = useState("");
  const [lname, setLName] = useState("");
  const [last4dights, setlast4dights] = useState("");
  const [idType, setidType] = useState("1");
  const [userName, setUserName] = useState("");
  const [isLoad, setIsLoad] = useState(true);
  const [dightsError, set4dightsError] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [AddEmployeDisiable, setAddEmployeDisiable] = useState(false);

  const [value, setValue] = useState("1");

  useEffect(() => {
    axios.get("Employee/AddEmployees")
      .then(res => {
        if (res?.data) {
          setCourses(res?.data?.data?.isNSKPQExists);
          setVCode(res?.data?.data?.vendorCode);
        }

        else {
          console.log(res?.data?.responseMessage);
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        setIsLoad(false);
      });
  }, []);
  const handleChange = async (ans) => {
    const Text = (fname + lname)?.replace(/\s/g, "")?.toLowerCase();
    if (ans == "1") {
      setUserName("");
    } else {
      setEmail("");
      setEmailErr("");
      if (fname != "" && lname != "") {
        axios.get("Employee/GetUserNameReccomendation?nameBase=" + Text)
          .then((res) => {
            if (res?.data?.responseCode == 100) {
              setUserName(res?.data?.data);
            }
          })
      }
    }
    setValue(ans);
  };

  const ChangeFirstName = (event) => {
    setFName(event?.target?.value);
  };
  const changeTitle = (ans) => {
    setTitle(ans);
  };
  const ChangeUserName = (ans) => {
    setUserName(ans?.replace(/\s/g, "")?.toLowerCase());
  };
  const changeEmail = (ans) => {
    let regEmail = /^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,20})[ ]*$/i;
    if (ans == "") {
      setEmail(ans);
      setEmailErr("");
    } else if (!regEmail?.test(ans)) {
      setEmail(ans);
      setEmailErr("Please check email format");
    } else {
      setEmail(ans);
      setEmailErr("");
    }
  };
  const ChangeLastName = (event) => {
    setLName(event?.target?.value);
  };
  const changeIdType = (ans) => {
    if (ans?.length == 4 || ans?.length == 0) {
      setlast4dights(ans);
      set4dightsError("");
    } else {
      setlast4dights(ans);
      set4dightsError("Please enter 4 digits");
    }

  };

  const ChangeId = (ans) => {
    setidType(ans);
  };
  const [isLoading, setIsLoading] = useState(false);
  const transferValue = (event) => {
    setIsLoading(true)
    event?.preventDefault();

    const val = {
      fname,
      title,
      email,
      lname,
      idType,
      last4dights,
      userName,
      value
    };
    if (email != "") {
      axios.get("Registration/HasEmailExists?email=" + email)
        .then((res) => {
          if (res?.data?.responseCode == 100) {
            addRows(val);
            //clearState();
          } else {
            toastNotify(res?.data?.responseMessage, false);
          }
        }).finally(() => {

        })
    } else if (userName != "") {
      axios.get("Employee/HasUserNameExists?userName=" + userName)
        .then((res) => {
          if (res?.data?.responseCode == 100) {
            addRows(val);
            //clearState();
          } else {
            toastNotify(res?.data?.responseMessage, false);
          }
        }).finally(() => {
          // setIsLoading(false)
        })
    }
    setIsLoading(false)
    // addRows(val);
    // clearState();
  };


  const clearState = () => {
    setFName("");
    setTitle("");
    setEmail("");
    setLName("");
    setlast4dights("");
    setUserName("");
    setidType("1");
    setValue("1");
  };
  const addRows = (data) => {
    let a = EmployeeData;
    if ((a?.find((r) => r?.email == email)) && (a?.find((r) => r?.userName == userName))) {
      toastNotify("Duplicate Email/Username not allowed", false);
    } else {
      a.push({ firstname: data?.fname, lastname: data?.lname, title: data?.title, last4dights: data?.last4dights, email: data?.email, idType: data?.idType, userName: data?.userName, isTrue: data?.value });
      const clonedObject = _.cloneDeep(a); // eslint-disable-line
      setEmployeeData(clonedObject);
      clearState();
    }
  };
  const RemoveEmploye = (data) => {
    var x = EmployeeData?.filter(function (item, index) {
      return index !== data
    })
    setEmployeeData(x);
  }
  const AddEmployes = () => {
    setAddEmployeDisiable(true);
    const Employees = EmployeeData?.map((r) => {
      return {
        "firstName": r?.firstname,
        "lastName": r?.lastname,
        "title": r?.title,
        "phoneNumber": "",
        "documentType": r?.idType,
        "last4Digits": r?.last4dights,
        "email": r?.email == "" ? r?.userName : r?.email,
        "userHasEmail": r?.isTrue == "1" ? true : false,
        "password": ""
      }
    })
    const data = {
      "employees": Employees
    }
    axios.post("Employee/AddEmployees", data)
      .then((res) => {
        if (res?.data?.responseCode == 100) {
          toastNotify(res?.data?.data, true);
          setAddEmployeDisiable(false);
          clearState();
          setEmployeeData([]);
          navigate("/EmployeesList");
        } else {
          toastNotify(res?.data?.responseMessage, false);
        }
      })

  }
  const [isDownloading, setIsDownloading] = useState(false);
  const DownloadTraingGuide = () => {
    setIsDownloading(true);
    axios.get("Documents/DownloadDoc?fileName=Employer Guide-Adding employees.pdf", {
      responseType: 'blob'
    })
      .then(res => {
        setIsDownloading(false);
        // const fileName = 'my_pdf_file.pdf';
        // const blob = new Blob([res.data], { type: 'application/pdf', filename: fileName });
        // const url = window.URL.createObjectURL(blob);
        // const link = document.createElement('a');
        // link.href = url;
        // link.setAttribute('download', fileName);
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
        // window.URL.revokeObjectURL(url);

        // const filename = 'your_desired_filename.pdf';
        // const file = new Blob([res.data], { type: "application/pdf", name: filename });
        // const fileURL = URL.createObjectURL(file);
        // const pdfWindow = window.open();
        // pdfWindow.location.href = fileURL;

        const file = new Blob([res?.data], { type: "application/pdf", name: "Employer Guide-Adding employees.pdf" });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        const pdfWindow = window.open();
        pdfWindow.document.write('<iframe width="100%" height="100%" src="' + fileURL + '" frameborder="0" title="YourFileName.pdf" allowfullscreen></iframe>');

        // const blob = new Blob([res.data], { type: res.headers['content-type'] });
        // const blobUrl = URL.createObjectURL(blob);
        // // Open the Blob URL in a new tab
        // window.open(blobUrl, '_blank');
        // // Revoke the Blob URL after opening to free up resources
        // URL.revokeObjectURL(blobUrl);
      });
  }

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading || isLoad}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastContainer />
      <Box sx={{ padding: "10px" }}>
        <p
          style={{
            color: "#101828",
            fontWeight: "600",
            fontSize: "28px",
            marginBottom: "10px",
          }}
        >
          Add Employees
        </p>
        <Box
          borderLeft={1}
          borderRight={1}
          border={1}
          borderColor="#e4e7ec"
          sx={{ padding: "20px", backgroundColor: "#fff" }}
        >

          {isDownloading ? (
            <CircularProgress />
          ) : (
            <a style={{ color: "#2A93DB", fontSize: "14px", cursor: "pointer" }} onClick={DownloadTraingGuide}>
              <InsertDriveFileOutlinedIcon /> Employer Guide-Adding employees.pdf
            </a>
          )}

          <p style={{ fontSize: "16px", fontWeight: "400", color: "red" }}>
            Make one payment for multiple employees by adding employees to the
            list before saving. Download and read "Employer Guide-Adding
            employees" from the Employees section for more information.
          </p>

          <p style={{ fontSize: "16px", fontWeight: "400", color: "red" }} hidden={!getCourse}>
            NSK contractors must enter employee names exactly as they appear on their driver's licenses.
          </p>
          <Box sx={{ flexGrow: 1 }}>
            <Grid
              container
              spacing={{ xs: 2, md: 1 }}
              columns={{ xs: 4, sm: 8, md: 12 }}
            >
              <Grid item xs={2} sm={4} md={3}>
                <span style={{ color: "#3E4A62", marginBottom: "2px" }}>
                  First Name<small style={{ color: "red" }}>*</small>
                </span>
                <br />
                <TextField
                  placeholder="First Name"
                  value={fname} onChange={ChangeFirstName}
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    fontFamily: "Arial, FontAwesome",
                    width: "320px",
                  }}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={2} sm={4} md={3}>
                <span style={{ color: "#3E4A62", marginBottom: "2px" }}>
                  Last Name<small style={{ color: "red" }}>*</small>
                </span>
                <br />
                <TextField
                  value={lname} onChange={ChangeLastName}
                  placeholder="Last Name"
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    fontFamily: "Arial, FontAwesome",
                    width: "320px",
                  }}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={2} sm={4} md={6}>
                <span style={{ color: "#3E4A62", marginBottom: "2px" }}>
                  Title<small style={{ color: "red" }}>*</small>
                </span>
                <br />
                <TextField
                  value={title} onChange={(e) => changeTitle(e?.target?.value)}
                  placeholder="Title  "
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    fontFamily: "Arial, FontAwesome",
                    width: "320px",
                  }}
                  variant="outlined"
                  size="small"
                />

              </Grid>
            </Grid>
            <br />
            <Grid
              container
              spacing={{ xs: 2, md: 1 }}
              columns={{ xs: 4, sm: 8, md: 12 }}
            >
              <Grid item xs={2} sm={4} md={3}>
                <span style={{ color: "#3E4A62", marginBottom: "2px" }}>
                  ID<small style={{ color: "red" }}>*</small>
                </span>
                <br />
                <FormControl >
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={idType}
                    label="Age"
                    size="small"
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                      fontFamily: "Arial, FontAwesome",
                      width: "320px",
                    }}
                    onChange={(e) => ChangeId(e?.target?.value)}
                  >
                    <MenuItem value={"1"}>Drivers license</MenuItem>
                    <MenuItem value={"2"}>Green Card</MenuItem>
                    <MenuItem value={"3"}>Social Security Number</MenuItem>
                    <MenuItem value={"4"}>Phone Number</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2} sm={4} md={3}>
                <span style={{ color: "#3E4A62", marginBottom: "2px" }}>
                  Last 4 Digits of ID <small style={{ color: "red" }}>*</small>
                </span>
                <br />
                <TextField
                  value={last4dights}
                  type='number'
                  InputProps={{ inputProps: { min: "1" } }}
                  onChange={(e) => changeIdType(e?.target?.value)}
                  placeholder="Last 4 Digits of ID "
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    fontFamily: "Arial, FontAwesome",
                    width: "320px",
                  }}
                  variant="outlined"
                  size="small"
                />
                <br />
                <span style={{ color: "red" }}>{dightsError}</span>
              </Grid>
            </Grid>
            <p
              style={{ fontSize: "16px", fontWeight: "400", marginTop: "20px" }}
            >
              User Name (Select Custom Username below if email address is
              already in use or employee does not have an email address)<small style={{ color: "red" }}>*</small>
            </p>
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={value}
                onChange={(e) => handleChange(e?.target?.value)}
              >
                <FormControlLabel value="1" control={<Radio />} label="Email Address" />

                <TextField
                  hidden={value == "2"}
                  value={email} onChange={(e) => changeEmail(e?.target?.value)}
                  placeholder="Email"
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                    fontFamily: "Arial, FontAwesome",
                    width: "320px",
                  }}
                  variant="outlined"
                  size="small"
                />
                <span style={{ color: "red" }}>{emailErr}</span>
                <FormControlLabel value="2" control={<Radio />} label="Custom Username" />
              </RadioGroup>
            </FormControl>
            <br />
            <TextField
              hidden={value == "1"}
              value={userName} onChange={(e) => ChangeUserName(e?.target?.value)}

              placeholder="Custom Username"
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                fontFamily: "Arial, FontAwesome",
                width: "320px",
              }}
              variant="outlined"
              size="small"
            />
            <br></br>
            {!fname ||
              !title ||
              !(email ||
                userName) ||
              !lname ||
              !last4dights ||
              !idType ||
              dightsError ||
              emailErr ? (<Tooltip title="Please fill all the mandatory field" followCursor>
                <span style={{ cursor: "not-allowed" }}>
                  <Button
                    variant="contained"
                    sx={{ padding: "15px", marginTop: "5px", }}
                    disabled={true}
                  >
                    + Add Employee to List
                  </Button>
                </span>
              </Tooltip>) : (<Button
                variant="contained"
                sx={{ padding: "15px", marginTop: "5px" }}
                onClick={transferValue}
                disabled={!fname ||
                  !title ||
                  !(email ||
                    userName) ||
                  !lname ||
                  !last4dights ||
                  !idType ||
                  dightsError ||
                  emailErr}
              >
                + Add Employee to List
              </Button>)}

          </Box>
        </Box>
        <Box
          hidden={EmployeeData?.length == 0}
          borderLeft={1}
          borderRight={1}
          borderColor="#e4e7ec"
          sx={{ padding: "20px", backgroundColor: "#fff", marginTop: "20px" }}
        >
          <p style={{
            color: "#101828",
            fontWeight: "400",
            fontSize: "18px",
            marginBottom: "10px",
          }}>Employees to Add</p>
          <TableContainer >

            <Table sx={{ minWidth: 700 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell sx={{ width: "20%" }}>Name</StyledTableCell>
                  <StyledTableCell align="left" sx={{ width: "20%" }}>Lastname</StyledTableCell>
                  <StyledTableCell align="left" sx={{ width: "25%" }}>Email/Username</StyledTableCell>
                  <StyledTableCell align="left" sx={{ width: "20%" }}>Title</StyledTableCell>
                  <StyledTableCell align="left" sx={{ width: "20%" }}>ID Type & ID No.&nbsp;</StyledTableCell>
                  <StyledTableCell align="left">&nbsp;</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {EmployeeData?.map((row, index) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell component="th" scope="row">
                      {row?.firstname}
                    </StyledTableCell>
                    <StyledTableCell align="left">{row?.lastname}</StyledTableCell>
                    <StyledTableCell align="left">{row?.email == "" ? row?.userName : row?.email}</StyledTableCell>
                    <StyledTableCell align="left">{row?.title}</StyledTableCell>
                    <StyledTableCell align="left">{INFO?.find((r) => r?.key == row?.idType)?.text} - {row?.last4dights}</StyledTableCell>
                    <StyledTableCell align="left"><DeleteIcon sx={{ color: "#667085", cursor: "pointer" }} onClick={() => RemoveEmploye(index)} /></StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <hr class="solid" />
          <Button
            variant="contained"
            sx={{ padding: "15px", marginTop: "5px" }}
            onClick={AddEmployes}
            disabled={AddEmployeDisiable}
          >
            Save
          </Button>
        </Box>
      </Box>
      <Box sx={{ padding: "10px" }}>
        <p
          style={{
            color: "#101828",
            fontWeight: "600",
            fontSize: "28px",
            marginBottom: "10px",
          }}
        >
          Employee Self Registration URL
        </p>

        <Box
          borderLeft={1}
          borderRight={1}
          border={1}
          borderColor="#e4e7ec"
          sx={{ padding: "20px", backgroundColor: "#fff" }}>
        
            <p style={{ fontSize: "16px", fontWeight: "400", color: "red" }}>
              Employees can use the below URL for self registration
            </p>
          
            <p style={{ fontSize: "400", color: "#101828", marginTop: "4px" }}>
              URL: <a href={"/EmployeeSelfRegistration?VendorCode=" + VCode} target="_blank" rel="noopener noreferrer">{window.location.origin + "/EmployeeSelfRegistration?VendorCode=" + VCode}</a>
            </p>


        </Box>
      </Box>
    </>
  );
}
